import AppListing from '../app-components/Listing/AppListing';

Vue.component('document-listing', {
    mixins: [AppListing]
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/document/Listing.js